// extracted by mini-css-extract-plugin
export default {"form__container":"AddPlaylistForm_form__container__7tE6g","form":"AddPlaylistForm_form__SjOyG"};